export function MatchPrepNotes() {
  return (
    <div className="space-y-10">

      {/* PAGE HEADER */}
      <div>
        <h1 className="text-3xl font-bold mb-2">Match Prep Notes</h1>
        <p className="text-muted">
          External intelligence for preparing anti-strats, map prep, and opponent-specific notes.
        </p>
      </div>

      {/* OPPONENT SELECTOR */}
      <section className="bg-surface border border-border rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Select Opponent</h2>

        <select
          className="
            w-full bg-bg border border-border rounded-md p-3
            focus:outline-none focus:border-[#4FC3F7]
          "
        >
          <option>Select a team...</option>
          <option>Team XYZ</option>
          <option>Team ABC</option>
          <option>Team Delta</option>
        </select>
      </section>

      {/* MATCH CONTEXT */}
      <section className="bg-surface border border-border rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Match Context</h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Match Date</p>
            <p className="font-semibold">Jan 28, 2026</p>
          </div>

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Division</p>
            <p className="font-semibold">Advanced</p>
          </div>

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Your Avg ELO</p>
            <p className="font-semibold text-[#4FC3F7]">2450</p>
          </div>

          <div className="bg-bg border border-border rounded-md p-4">
            <p className="text-muted text-sm">Opponent Avg ELO</p>
            <p className="font-semibold text-[#4FC3F7]">2380</p>
          </div>

        </div>
      </section>

      {/* NOTES GRID */}
      <div className="grid lg:grid-cols-2 gap-8">

        {/* TENDENCIES */}
        <section className="bg-surface border border-border rounded-lg p-6 flex flex-col">
          <h2 className="text-xl font-semibold mb-4">Opponent Tendencies</h2>

          <textarea
            placeholder="How do they play defaults? Do they favor fast hits? Who entries? Who lurks?"
            className="
              flex-grow w-full bg-bg border border-border rounded-md p-3
              focus:outline-none focus:border-[#4FC3F7]
            "
          />
        </section>

        {/* WEAKNESSES */}
        <section className="bg-surface border border-border rounded-lg p-6 flex flex-col">
          <h2 className="text-xl font-semibold mb-4">Weaknesses</h2>

          <textarea
            placeholder="Where are their weak spots? Which sites do they struggle to hold? Who tilts?"
            className="
              flex-grow w-full bg-bg border border-border rounded-md p-3
              focus:outline-none focus:border-[#4FC3F7]
            "
          />
        </section>

        {/* MAP PREP */}
        <section className="bg-surface border border-border rounded-lg p-6 flex flex-col">
          <h2 className="text-xl font-semibold mb-4">Map Prep</h2>

          <textarea
            placeholder="Map-specific notes: setups, executes, CT protocols, anti-exec ideas."
            className="
              flex-grow w-full bg-bg border border-border rounded-md p-3
              focus:outline-none focus:border-[#4FC3F7]
            "
          />
        </section>

        {/* ANTI-STRATS */}
        <section className="bg-surface border border-border rounded-lg p-6 flex flex-col">
          <h2 className="text-xl font-semibold mb-4">Anti-Strats</h2>

          <textarea
            placeholder="Counter their favorite plays. Deny their comfort zones. Exploit their habits."
            className="
              flex-grow w-full bg-bg border border-border rounded-md p-3
              focus:outline-none focus:border-[#4FC3F7]
            "
          />
        </section>

      </div>

      {/* SHARED TEAM NOTES */}
      <section className="bg-surface border border-border rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Shared Team Notes</h2>

        <textarea
          placeholder="General notes for your team. Everyone can contribute here."
          className="
            w-full h-40 bg-bg border border-border rounded-md p-3
            focus:outline-none focus:border-[#4FC3F7]
          "
        />
      </section>

    </div>
  );
}